var _InputDefaultStyles, _rounded, _sm, _rounded2, _md, _rounded3, _lg;

import styled, { css } from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import 'react';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
import { color, variant, themeMode } from '../../utils/theme.es.js';
var InputDefaultStyles = (_InputDefaultStyles = {
  display: "flex",
  alignItems: "center",
  flex: "1 1 25%",
  zIndex: 1,
  position: "relative",
  lineHeight: "normal",
  width: "100%",
  minWidth: "75px",
  color: "inherit",
  backgroundColor: "transparent",
  border: "none",
  boxShadow: "none",
  appearance: "none",
  filter: "none",
  "&:focus": {
    outline: "none"
  }
}, _InputDefaultStyles["&::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration"] = {
  display: "none"
}, _InputDefaultStyles["&:-webkit-autofill,\n    &:-webkit-autofill:hover,\n    &:-webkit-autofill:focus,\n    &:-webkit-autofill:active"] = {
  transition: "background-color 99999s ease-in-out 99999s, color 99999s ease-in-out 99999s"
}, _InputDefaultStyles);
var Input = styled(Box).withConfig({
  componentId: "sc-142i596-0"
})(["", ";", ";&:disabled{color:", ";-webkit-text-fill-color:", ";}@media screen and (pointer:coarse){font-size:16px;}"], InputDefaultStyles, function (_ref) {
  var isMultiline = _ref.isMultiline,
      size = _ref.size;
  return isMultiline && !!size && inputSizes;
}, color("neutral.400"), color("neutral.400"));
Input.defaultProps = {
  as: "input"
};
Input.displayName = "Styled.Input";
var Addon = styled(Box).withConfig({
  componentId: "sc-142i596-1"
})({
  display: "flex",
  alignItems: "center",
  flex: "0 1 auto",
  overflow: "hidden",
  zIndex: 2
});
var inputSizes = variant({
  prop: "size",
  compoundProp: "shape",
  variants: {
    sm: (_sm = {
      fontSize: "sm",
      height: "36px",
      minHeight: "36px"
    }, _sm["& > " + Input] = {
      px: "sm"
    }, _sm.rounded = (_rounded = {}, _rounded["& > " + Input] = {
      px: "md"
    }, _rounded), _sm),
    md: (_md = {
      fontSize: "md",
      height: "48px",
      minHeight: "48px"
    }, _md["& > " + Input] = {
      px: "md"
    }, _md.rounded = (_rounded2 = {}, _rounded2["& > " + Input] = {
      px: "lg"
    }, _rounded2), _md),
    lg: (_lg = {
      fontSize: "lg",
      height: "64px",
      minHeight: "64px"
    }, _lg["& > " + Input] = {
      px: "lg"
    }, _lg.rounded = (_rounded3 = {}, _rounded3["& > " + Input] = {
      px: "xl"
    }, _rounded3), _lg)
  }
});
var inputShapes = variant({
  prop: "shape",
  variants: {
    default: {
      borderRadius: "sm"
    },
    rounded: {
      borderRadius: "round"
    }
  }
});
var inputVariants = variant({
  prop: "variant",
  variants: {
    outlined: themeMode({
      dark: {
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "neutral.600",
        backgroundColor: "transparent",
        color: "neutral.50",
        position: "relative",
        "input::placeholder": {
          color: "neutral.400"
        },
        "&:hover": {
          borderColor: "neutral.400"
        },
        "&:focus-within": {
          borderColor: "neutral.50"
        },
        isInvalid: {
          borderColor: "danger.500"
        },
        isDisabled: {
          color: "neutral.400",
          borderColor: "transparent",
          backgroundColor: "neutral.800",
          "&:hover": {
            borderColor: "transparent"
          }
        }
      },
      light: {
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "neutral.300",
        backgroundColor: "neutral.0",
        color: "neutral.900",
        "input::placeholder": {
          color: "neutral.400"
        },
        "&:hover": {
          borderColor: "neutral.600"
        },
        "&:focus-within": {
          borderColor: "neutral.900"
        },
        isInvalid: {
          borderColor: "danger.500"
        },
        isDisabled: {
          color: "neutral.400",
          borderColor: "transparent",
          backgroundColor: "neutral.100",
          "&:hover": {
            borderColor: "transparent"
          }
        }
      }
    }),
    filled: themeMode({
      dark: {
        backgroundColor: "neutral.800",
        color: "neutral.50",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "transparent",
        "input::placeholder": {
          color: "neutral.400"
        },
        isInvalid: {
          borderColor: "danger.500"
        },
        isDisabled: {
          color: "neutral.400",
          borderColor: "transparent",
          backgroundColor: "neutral.800",
          "&:hover": {
            borderColor: "transparent"
          }
        }
      },
      light: {
        backgroundColor: "neutral.100",
        color: "neutral.900",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "transparent",
        "input::placeholder": {
          color: "neutral.400"
        },
        isInvalid: {
          borderColor: "danger.500"
        },
        isDisabled: {
          color: "neutral.400",
          borderColor: "transparent",
          backgroundColor: "neutral.100",
          "&:hover": {
            borderColor: "transparent"
          }
        }
      }
    }),
    ghost: themeMode({
      dark: {
        backgroundColor: "transparent",
        border: "1px solid transparent",
        color: "neutral.50",
        padding: 0,
        "input::placeholder": {
          color: "neutral.400"
        },
        isInvalid: {
          borderBottomColor: "danger.500"
        },
        isDisabled: {
          color: "neutral.400",
          borderColor: "transparent",
          "&:hover": {
            borderColor: "transparent"
          }
        }
      },
      light: {
        backgroundColor: "transparent",
        border: "1px solid transparent",
        color: "neutral.900",
        padding: 0,
        "input::placeholder": {
          color: "neutral.500"
        },
        isInvalid: {
          color: "danger.500"
        },
        isDisabled: {
          color: "neutral.400",
          borderColor: "transparent",
          "&:hover": {
            borderColor: "transparent"
          }
        }
      }
    })
  }
});
var Wrapper = styled(Box).withConfig({
  componentId: "sc-142i596-2"
})({
  display: "flex",
  justifyItems: "center",
  alignItem: "center",
  position: "relative",
  transition: "border-color 200ms ease-in, box-shadow 200ms ease-in"
}, css(["&:focus-within{box-shadow:", " 0px 0px 0px 1px;}"], themeMode({
  dark: color("neutral.50"),
  light: color("neutral.900")
})), inputSizes, inputShapes, inputVariants, function (_ref2) {
  var isMultiline = _ref2.isMultiline;
  return isMultiline && {
    alignItems: "center",
    flexWrap: "wrap",
    minHeight: "48px",
    height: "auto"
  };
});
Wrapper.displayName = "Styled.InputWrapper";
export { Addon, Input, InputDefaultStyles, Wrapper, inputShapes, inputSizes, inputVariants };